/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


